import { reduxSetter } from '../../../../../utils/reduxSetter';
import {
    SET_REF_BIKE_LEAD_REDUCER,
    CHANGE_REF_BIKE_LEAD_REQUEST,
    CHANGE_REF_BIKE_LEAD_REQUEST_SUCCESS,
    CHANGE_REF_BIKE_LEAD_REQUEST_FAILURE,
    GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS,
    GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_FAILURE,
    UPDATE_BIKE_LEAD_UPGRADES_REQUEST,
    UPDATE_BIKE_LEAD_UPGRADES_SUCCESS,
    CHANGE_LEAD_POT,
} from '../constants/get_lead_profile.constants';

import {
    SEARCH_BIKE_VARIANT_REQUEST_SUCCESS,
    SEARCH_BIKE_VARIANT_REQUEST_FAILURE,
} from '../../../../PlatformManagement/BikeManagement/redux/constants/bike_model.constants';
import { BIKE_UPGRADES_REQUEST } from '../constants/bike_upgrades.constants';

const initialState = () => ({
    loading: true,
    bike_details: {},
    years: [],
    part_ex: {},
    is_manager_special: false,
    use_live_price: false,
    served_live_price: false,
    lead_pot: 'Unknown',
    error: null,
    isBikeUpgradesFetching: false,
    isFetchingUpgrades: false,
    vin_check: '',
});

export const Ref_bike_lead = (state = initialState(), action) => {
    switch (action.type) {
    case 'SET_REF_BIKE_LEAD_DATA':
        return reduxSetter(state, action);
    case 'RESET_BIKE_DETAILS': {
        return initialState();
    }
    case SET_REF_BIKE_LEAD_REDUCER:
    case GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS:
        return {
            ...state,
            bike_details: action.payload,
            part_ex: action.part_ex,
            is_manager_special: action.is_manager_special,
            use_live_price: action.use_live_price,
            served_live_price: action.served_live_price,
            lead_pot: action.lead_pot,
            customer_collection_date: action.customer_collection_date,
            completed_blemish_step: action.completed_blemish_step,
            has_completed_blemish: action.has_completed_blemish,
            photos: action.photos,
            loading: false,
            vin_check: action.vin_check,
        };
    case CHANGE_REF_BIKE_LEAD_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CHANGE_LEAD_POT:
        return {
            ...state,
            lead_pot: action.payload,
        };
    case CHANGE_REF_BIKE_LEAD_REQUEST_SUCCESS:
        if (action.key === 'ref_bike_lead') {
            return {
                ...state,
                ref_bike_lead: action.data,
                loading: false,
            };
        }
        return {
            ...state,
            bike_details: {
                ...state.bike_details,
                [action.key]: action.data,
            },
            loading: false,
        };
    case UPDATE_BIKE_LEAD_UPGRADES_REQUEST:
        return {
            ...state,
            isFetchingUpgrades: true,
            bike_details: {
                ...state.bike_details,
                upgrades: null,
            },

        };
    case UPDATE_BIKE_LEAD_UPGRADES_SUCCESS:
        return {
            ...state,
            isFetchingUpgrades: false,
            bike_details: {
                ...state.bike_details,
                [action.key]: action.data || [],
            },
        };

    case SEARCH_BIKE_VARIANT_REQUEST_SUCCESS:
        return {
            ...state,
            years: action.payload,
        };
    case CHANGE_REF_BIKE_LEAD_REQUEST_FAILURE:
    case GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_FAILURE:
    case SEARCH_BIKE_VARIANT_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };

    case BIKE_UPGRADES_REQUEST:
        return {
            ...state,
            loading: false,
        };

    case BIKE_UPGRADES_REQUEST:
        return {
            ...state,
            loading: false,
        };

    case BIKE_UPGRADES_REQUEST:
        return {
            ...state,
            loading: false,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/ref_bike_lead.reducer.js